import { render, staticRenderFns } from "./ForcPeerReviewPerformanceComparison.vue?vue&type=template&id=72792092&"
import script from "./ForcPeerReviewPerformanceComparison.vue?vue&type=script&lang=js&"
export * from "./ForcPeerReviewPerformanceComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports